<template>
  <div class="info-block">
    <div class="info-card">
      <div class="info-left">
        <div class="info-title">
          <p>{{ title }}</p>
        </div>
        <slot name="input"></slot>
      </div>

      <!-- <div class="info-right">
        <a v-if="url != null" :style="'background-color: ' + $store.state.event.event.color" :href="url" target="_blank">
          <span> {{ button }} </span>
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBlock",
  props: ["title", "desc", "button", "url"],
  data() {
    return {};
  }
};
</script>

<style lang="less">
.info-block {
  display: contents;
  width: 100%;
  position: relative;
  h4,
  h5 {
    margin: 0;
  }

  .info-card {
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
    display: flex;
    width: 100%;
    background-color: #fff;
    padding: 16px 14px;
    box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
    border-radius: 12px;
    margin-top: 20px;
    margin-bottom: 20px;

    .info-left {
      width: 100%;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 6px;
      gap: 1rem;
      width: 100%;
      .info-info {
        margin: 0px;
        margin-top: 4px;
        width: 100%;
        span {
          color: #505763;
          font-size: 14px;
        }
      }

      .info-title {
        line-height: 25px;
        p {
          text-overflow: ellipsis;
          max-width: 540px !important;
          white-space: nowrap;
          overflow: hidden;
          margin: 0px;
          display: block;
          color: #292f3b;
          font-weight: 600;
          font-size: 22px;
        }
      }
    }

    .info-right {
      a {
        border: none;
        outline: none;
        padding: 10px 20px;
        background-color: whitesmoke;
        font-weight: bold;
        color: white;
        margin-left: 45px;
        border-radius: 8px;
        font-family: "Roboto";
        cursor: pointer;
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 768px) {
  .info-block {
    .info-card {
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .info-left {
        text-align: center;
        margin-left: 0px;
        .info-title {
          p {
            margin: 0px auto;
          }
        }
      }

      .info-right {
        margin-top: 20px;
        a {
          margin-left: 0px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/InfoBlock.vue